export default "__VITE_ASSET__pHq3nIOK__"